<template>
  <section
    class="relative py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 overflow-hidden bg-gradient-to-br from-[#f4f4f4] via-[#f8f9fa] to-[#e9ecef]"
  >
    <!-- Removed dark overlay and changed main background -->

    <!-- Animated Background Blobs - adjusted for light theme -->
    <div class="absolute inset-0 overflow-hidden -z-0">
      <div
        class="absolute -top-40 -right-40 w-60 h-60 sm:w-80 sm:h-80 bg-[#fe6d0d] rounded-full mix-blend-multiply filter blur-2xl opacity-10 animate-blob"
      ></div>

      <div
        class="absolute -bottom-40 -left-40 w-60 h-60 sm:w-80 sm:h-80 bg-[#ffb47c] rounded-full mix-blend-multiply filter blur-2xl opacity-10 animate-blob animation-delay-2000"
      ></div>

      <div
        class="absolute top-40 left-40 w-60 h-60 sm:w-80 sm:h-80 bg-[#0b105d] rounded-full mix-blend-multiply filter blur-2xl opacity-5 animate-blob animation-delay-4000"
      ></div>
    </div>

    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 relative z-10">
      <header class="text-center mt-12 sm:mt-16" data-aos="fade-down">
        <h1
          class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#fe6d0d] to-[#ff8c42] pb-4 sm:pb-6 sm:pt-6 animate-gradient"
        >
          {{ $t('contactPage.title') }}
        </h1>
        <p
          class="text-base sm:text-lg md:text-xl text-[#0b105d]/80 max-w-2xl sm:max-w-3xl mx-auto leading-relaxed"
        >
          {{ $t('contactPage.intro') }}
        </p>
      </header>
    </div>
  </section>
</template>

<script setup lang="ts"></script>

<style scoped>
@keyframes blob {
  0% {
    transform: translate(0px, 0px) scale(1);
  }
  33% {
    transform: translate(30px, -50px) scale(1.1);
  }
  66% {
    transform: translate(-20px, 20px) scale(0.9);
  }
  100% {
    transform: translate(0px, 0px) scale(1);
  }
}

.animate-blob {
  animation: blob 10s infinite;
}

.animation-delay-2000 {
  animation-delay: 2s;
}

.animation-delay-4000 {
  animation-delay: 4s;
}
</style>
